import React from 'react';
import { Autocomplete, Divider, Paper, Stack, TextField } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { ICallLangMenuListProps } from './types';
import { Text } from '../../../../../common/components/Text/Text';
import LangFlag from '../../../shared/LangFlag/LangFlag';
import { TLangSelectOption } from '../../../LangSelect/components/types';

export function CallLangMenuList({
	langCode,
	options,
	onChange,
	onClose,
}: ICallLangMenuListProps) {

	const handleChange = (e: React.SyntheticEvent, newValue: TLangSelectOption | null) => {
		if (newValue) {
			onChange(newValue.code);
			onClose();
		}
	};

	const [lastGroupLangCode, setLastGroupLangCode] = React.useState<string | null>(null);
	React.useEffect(() => {
		let lastGroupLang = '';
		for (let i = 0; i < options.length; i++) {
			if (options[i].itemsCount === null) break;
			lastGroupLang = options[i].code;
		}
		setLastGroupLangCode(lastGroupLang);
	}, [options]);

	const [opened, setOpened] = React.useState(false);
	React.useEffect(() => {
		setTimeout(() => {
			setOpened(true);
		}, 300);
	}, []);

	const selectStyle = {
		minWidth: theme.spacing(24.75),
	};

	const dropdownStyle = {
		boxShadow: theme.shadows[8],
	};

	return (
		<>
			<Autocomplete
				autoHighlight
				disabled={!options || !options.length}
				open={opened}
				options={options}
				getOptionLabel={(option) => option.name}
				// value={options.find((option) => option.code === langCode) || null as any}
				onChange={handleChange}
				onClose={onClose}
				sx={selectStyle}
				PaperComponent={({ children, ...other }) => (
					<Paper {...other} style={dropdownStyle}>
						{children}
					</Paper>
				)}
				renderInput={(params) => {
					return <TextField
						{...params}
						autoFocus
						variant="filled"
						InputLabelProps={{
							shrink: true,
						}}
					/>;
				}}
				renderOption={(props, option) => {
					const { key, ...optionProps } = props as any;
					return (
						<React.Fragment key={key}>
							<li {...optionProps}>
								<Stack direction="row" alignItems="center" gap={theme.spacing(1)}>
									<LangFlag code={option.code} showCode={false} />
									<Text variant={'subtitle2'}>
										{option.highlight ? <b>{option.name}</b> : option.name}
									</Text>
								</Stack>
							</li>
							{option.code === lastGroupLangCode && <Divider />}
						</React.Fragment>
					);
				}}
			/>
		</>
	);
};
